import { useLanguage } from '../context/LanguageContext';
import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useHotel } from '../context/HotelContext';

const VirtualTour = () => {
  const { t } = useLanguage();
  const { hotelInfo } = useHotel();
  
  return (
    <section id="360-tour" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-orange-500 font-semibold mb-2 text-sm uppercase tracking-wider">{t('virtualTour.subtitle')}</p>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 text-gray-900">{t('virtualTour.title')}</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">{t('virtualTour.description')}</p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Virtual Tour Iframe */}
          <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-gray-100" style={{ paddingBottom: '56.25%', height: 0 }}>
            <iframe
              src={hotelInfo.virtualTourIframe}
              className="absolute top-0 left-0 w-full h-full"
              frameBorder="0"
              allowFullScreen
              title="Hotel La Rosa Negra Virtual Tour"
            />
          </div>

          {/* Tour features */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6 text-center border border-orange-200">
              <div className="text-3xl mb-2">🏊</div>
              <h3 className="font-bold text-lg mb-1 text-gray-900">Rooftop Pool</h3>
              <p className="text-sm text-gray-600">Experience our stunning rooftop swimming pool with panoramic views</p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6 text-center border border-orange-200">
              <div className="text-3xl mb-2">🍽️</div>
              <h3 className="font-bold text-lg mb-1 text-gray-900">Restaurant</h3>
              <p className="text-sm text-gray-600">Discover our elegant dining area serving delicious cuisine</p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6 text-center border border-orange-200">
              <div className="text-3xl mb-2">🛌</div>
              <h3 className="font-bold text-lg mb-1 text-gray-900">Guest Rooms</h3>
              <p className="text-sm text-gray-600">Tour our comfortable and well-appointed guest rooms</p>
            </div>
          </div>

          {/* External link */}
          <div className="text-center mt-8">
            <a
              href={hotelInfo.virtualTour}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl"
            >
              Open Full 360° Tour
              <ExternalLink size={20} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VirtualTour;